import axios from 'axios'

const getDefaultSystemMessageState = () => {
  return {
    system_messages: {},
  }
}

export default {
  state: getDefaultSystemMessageState,
  mutations: {

  },

  actions: {
    getSystemMessageEditData ({ commit, state }, { systemMessageId }) {
      return axios.get(`/admin/system-messages/${systemMessageId}/edit-data`)
    },

    createSystemMessage ({ commit, state }, { data }) {
      return axios.post('/admin/system-messages', data)
    },

    updateSystemMessage ({ commit, state }, { systemMessageId, data }) {
      return axios.put(`/admin/system-messages/${systemMessageId}`, data)
    },
  },

  getters: {},
}
